import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'vcp-switch-workspace-warning-popup',
  templateUrl: './switch-workspace-warning-popup.component.html',
  styleUrls: ['./switch-workspace-warning-popup.component.scss']
})
export class SwitchWorkspaceWarningPopupComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<SwitchWorkspaceWarningPopupComponent>
  ) { }

  ngOnInit(): void {
  }

  switchWorkspace(){
    this.dialogRef.close(true);
  }

}
